// @flow
import { LocationActionTypes } from './actionTypes';
import axios from 'axios';
import { CommonMapper } from 'mappers/common';

const getUserLocation = (productId: string) => (
  dispatch,
  getState,
  { api }
) => {
  dispatch({
    type: LocationActionTypes.LOCATION.FETCH,
    payload: {},
    test: api
      .post('getIpDetails.json')
      .then(res => {
        const response = res.data.data || {};
        dispatch({
          type: LocationActionTypes.LOCATION.SUCCESS,
          payload: CommonMapper.mapUserLocation(response),
        });
      })
      .catch(error => {
        dispatch({
          type: LocationActionTypes.LOCATION.FAILURE,
          error,
        });
      }),
  });
};

export const LocationActions = {
  getUserLocation,
};
